export const FILTER_NAME = 'customer'
